import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Section, Container, SectionHeader, SectionTitle, SectionSubTitle } from './SplashPageSharedComponents';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { AllProductLines } from 'self-service-api/constants/ProductLines';
import SplashPageCard from './SplashPageCard';
import UICardGrid from 'UIComponents/card/UICardGrid';
import { isAppAuthSelector } from '../../selectors/AuthSelectors';
import { useAppSelector } from '../../reducers';
import { COMMERCE } from 'self-service-api/constants/EnrolledProductLines';

const ProductsSection = ({
  selectedTab,
  sectionProps
}) => {
  const isAppAuth = useAppSelector(isAppAuthSelector);
  const productLines = [...AllProductLines, COMMERCE];
  const productLineTiles = productLines.map(productLine => {
    return /*#__PURE__*/_jsx(SplashPageCard, {
      titleKey: `splash-page.products.${productLine}.title`,
      descriptionKey: `splash-page.products.${productLine}.description.${selectedTab}`,
      pathname: isAppAuth || productLine === 'COMMERCE' ? `/${productLine.toLowerCase()}` : `/${productLine.toLowerCase()}/${selectedTab}`,
      showIcon: true,
      productLine: productLine
    }, productLine);
  });
  return /*#__PURE__*/_jsx(Section, Object.assign({}, sectionProps, {
    children: /*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsxs(SectionHeader, {
        children: [/*#__PURE__*/_jsx(SectionTitle, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `splash-page.products.title.${selectedTab}`
          })
        }), /*#__PURE__*/_jsx(SectionSubTitle, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `splash-page.products.subtitle.${selectedTab}`
          })
        })]
      }), /*#__PURE__*/_jsx(UICardGrid, {
        children: productLineTiles
      })]
    })
  }));
};

export default ProductsSection;